import { render, staticRenderFns } from "./medicenecat.vue?vue&type=template&id=53d1dae4"
import script from "./medicenecat.vue?vue&type=script&lang=js"
export * from "./medicenecat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports